import { render, staticRenderFns } from "./ViewJitsers.vue?vue&type=template&id=024cc8b6&scoped=true"
import script from "./ViewJitsers.vue?vue&type=script&lang=js"
export * from "./ViewJitsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024cc8b6",
  null
  
)

export default component.exports